import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { BLANK_OPTION } from '../../../common/order/popup/popupConfirmationBuyNowOrAddCart/constants'
import { SelectCustom } from '../../../common/selectCustom'
import TextEllipsis from '../../../common/textEllipsis'
import { Z_INDEX } from '../../../utils/common'

export const ItemSelect = ({
  data,
  label,
  activeItem,
  setActive,
  keySelect,
  isI18n,
  disabled,
}) => {
  const chooseItem = (item) => {
    const isBlank = item.value === BLANK_OPTION.value

    setActive((prev) => ({
      ...prev,
      [keySelect]: isBlank ? {} : item,
    }))
  }

  return (
    <div className="dFlex gap2 alignItemsCenter">
      <Element className="flex1 fw600">
        <Translate value={label} />
      </Element>
      <SelectCustom
        style={{ width: 200 }}
        data={data}
        activeItem={activeItem}
        chooseItem={chooseItem}
        zIndex={Z_INDEX.MODAL + 1}
        isI18n={isI18n}
        disabled={disabled}
        renderActiveItem={(activeItem) => (
          <TextEllipsis
            text={
              activeItem.value === BLANK_OPTION.value ? ' ' : activeItem.label
            }
            isI18n
            zIndexTooltip={Z_INDEX.MODAL + 1}
          />
        )}
      />
    </div>
  )
}
